import { render, staticRenderFns } from "./partnerShipsAdd.vue?vue&type=template&id=6ec708a0&scoped=true"
import script from "./partnerShipsAdd.vue?vue&type=script&lang=js"
export * from "./partnerShipsAdd.vue?vue&type=script&lang=js"
import style0 from "./partnerShipsAdd.vue?vue&type=style&index=0&id=6ec708a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec708a0",
  null
  
)

export default component.exports